import { electronUpdater } from '@todesktop/client-core'
import { storage } from '@/helpers/utils'
import moment from 'moment'
import { createLogger } from './log'

const log = createLogger('DESKTOP')

const UPDATE_CHECK_INTERVAL = 1800000 // 30 mins

export const checkForAppUpdates = async () => {
	if (!window.todesktop) return
	return new Promise(async (resolve) => {
		try {
			// check to see when we last checked for updates
			const lastCheck = storage.get('desktop_update_check')
			const millisAgo = moment().diff(lastCheck)
			if (lastCheck && millisAgo < UPDATE_CHECK_INTERVAL) {
				// we already checked recently so just bail...
				const timeAgo = moment(lastCheck).fromNow()
				log('not checking for updates, last checked', timeAgo)
				return resolve({})
			}
			// we need to check if a new update is available
			const currentVersion = window.todesktop.version
			log('checking for updates...', currentVersion)
			const response = await electronUpdater.checkForUpdates()
			if (!response) {
				log('no version info available, probably using unreleased app')
				return resolve({})
			}
			log('latest available version:', response)
			const { version: newVersion } = response.versionInfo || {}
			// update our last checked timestamp so we don't check again too frequently
			storage.set('desktop_update_check', new Date())
			const ignoredVersion = storage.get('desktop_update_ignored')
			const hasIgnored = newVersion === ignoredVersion
			if (hasIgnored) {
				log('user ignored update:', newVersion)
				return resolve({})
			}
			const needsToUpdate = newVersion !== currentVersion
			if (!needsToUpdate) {
				// no new version available so just bail
				log('no need to update', { newVersion, currentVersion })
				return resolve({})
			}

			const result = await electronUpdater.downloadUpdate()
			log('update downloaded successfully', result)
			resolve({
				version: newVersion,
				needsToUpdate,
				currentVersion,
			})
		} catch (e) {
			log('update check error')
			console.error(e)
			return resolve({})
		}
	})
}

export const updateAppAndRestart = async () => {
	if (!window.todesktop) return
	try {
		log('quitting and installing update...')
		await electronUpdater.quitAndInstall()
		log('installation complete')
	} catch (e) {
		log('update download error')
		console.error(e)
	}
}
